<section [id]="id()" class="container h-fit">
  @if (title() !== '') {
    <article class="pl-4 pt-4">
      <h1 class="title">{{ literalService.get(title(), true) }}</h1>
    </article>
  }
  <section class="px-4 py-4">
    @for (option of options(); track $index) {
      <div [id]="option.id" class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mb-2 items-center cursor-pointer bg-white" [ngClass]="{ 'active': selectedOption() === option.value, 'disabled': option.disabled }" (click)="selectValue(option.value)">
        @if (option.icon) {
          <img [src]="option.icon" class="w-6 h-6" />
        }
        <label [id]="`${id()}-label`" class="ml-2 cursor-pointer truncate" [tooltip]="option.label" [visibleTooltip]="utilsService.visibleTooltip(`${id()}-label`)">{{ literalService.get(option.label, true) }}</label>
      </div>
    }
  </section>
</section>